export const getMaxPossiblePageSize = (totalCount: any, pageSize: any) => {
  return Math.ceil(totalCount / pageSize);
};
